import { render, staticRenderFns } from "./ModalDesativarUsuario.vue?vue&type=template&id=0ffb1dc3"
import script from "./ModalDesativarUsuario.vue?vue&type=script&lang=js"
export * from "./ModalDesativarUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports